var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoItem"},[_c('div',{staticClass:"infoTtile"},[_vm._v(_vm._s(_vm.infoTtile))]),_c('div',{staticClass:"infoAbout"},[_vm._v(_vm._s(_vm.infoAbout))]),_c('div',{staticClass:"infoImg"})])}
var staticRenderFns = []

export { render, staticRenderFns }